var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-circle-svgrepo-com",
    transform: "translate(-2 -2.01)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34381",
    "data-name": "Path 34381",
    d: "M14,26.01a12,12,0,1,0-12-12A12,12,0,0,0,14,26.01Z",
    transform: "translate(0 0)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34382",
    "data-name": "Path 34382",
    d: "M12.683,6.94a4.427,4.427,0,0,0-.059,8.854h.213a4.428,4.428,0,0,0-.154-8.854Z",
    transform: "translate(1.317 1.039)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34383",
    "data-name": "Path 34383",
    d: "M21.608,20.042a12.282,12.282,0,0,1-16.387,0,5.068,5.068,0,0,1,2.224-2.813,11.851,11.851,0,0,1,11.94,0A5.017,5.017,0,0,1,21.608,20.042Z",
    transform: "translate(0.587 2.835)",
    fill: "#292d32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyprofile);
export default __webpack_public_path__ + "static/media/emptyprofile.4ac8a732258c78f3fde34101b2493e29.svg";
export { ForwardRef as ReactComponent };